<template>
  <ProposalsListCotizacionesClienteFilters />
  <el-table
    :data="cotizacionCantidadListFiltered"
    style="width: 990px; margin-bottom: 40px; margin: 0 auto"
    :border="true"
    :header-cell-style="headerStyle"
    size="default"
    @selection-change="handleSelectionChange"
  >
    <el-table-column
      type="selection"
      width="55"
    />
    <el-table-column
      prop="CodigoCotizacion"
      label="Nro Cotizacion"
      width="130"
    />
    <el-table-column
      prop="FechaCreacion"
      label="Fecha"
      width="100"
    >
      <template #default="scope">
        {{ useFormatDate().formatHumanDate(scope.row.FechaCreacion) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="Referencia"
      label="Producto"
      width="600"
    />
    <el-table-column
      prop="Cantidad"
      label="Cantidad"
      width="100"
    ></el-table-column>
  </el-table>

  <el-row
    justify="end"
    style="padding-right: 100px"
  >
    <div class="fixed-button">
      <el-button
        type="primary"
        size="default"
        :icon="IconAdd"
        @click="addToProposal"
        >Agregar a la propuesta</el-button
      >
    </div>
  </el-row>
</template>

<script setup>
import {
  onBeforeMount,
  ref,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useCotizacionCantidadStore } from '@/stores/cotizacion-cantidad/cotizacion-cantidad_store';
import { useProposalsStore } from '../../proposals_store';
import { useFormatDate } from '@/shared/composables/format_date.js';
import ProposalsListCotizacionesClienteFilters from './proposals_list_cotizaciones_cliente_filters.vue';
import IconAdd from '~icons/mdi/add';

const cotizacionCantidadStore = useCotizacionCantidadStore();
const { cotizacionCantidadList } = storeToRefs(cotizacionCantidadStore);
const { findAllCotizacionCantidadHTTP, emptyList: emptyCotizacionCantidadList } =
  cotizacionCantidadStore;

const proposalsStore = useProposalsStore();
const { proposal, isOpenDrawerSelection } = storeToRefs(proposalsStore);

const multipleSelection = ref([]);

const cotizacionCantidadListFiltered = computed(() => {
  const savedCotizacionCantidad = [];
  proposal.value.PropuestaCotizacionCantidad.forEach((cotizacion) => {
    savedCotizacionCantidad.push(
      ...cotizacion.items
        .sort((a, b) => (a.Orden > b.Orden ? 1 : 0))
        .map((i) => i.CodigoCotizacionCantidad),
    );
  });

  return cotizacionCantidadList.value.filter((c) => {
    return !savedCotizacionCantidad.includes(c.CodigoCotizacionCantidad);
  });
});

const handleSelectionChange = (itemsSelected) => {
  multipleSelection.value = itemsSelected;
};

const headerStyle = () => {
  return { 'background-color': '#808080', color: '#ccc' };
};

const addToProposal = async () => {
  multipleSelection.value.forEach((selection) => {
    const index = proposal.value.PropuestaCotizacionCantidad.findIndex(
      (i) => i.CodigoCotizacion === selection.CodigoCotizacion,
    );

    if (index >= 0) {
      proposal.value.PropuestaCotizacionCantidad[index].items.push(selection);
    } else {
      proposal.value.PropuestaCotizacionCantidad.push({
        CodigoCotizacion: selection.CodigoCotizacion,
        items: [{ ...selection }],
      });
    }
  });
  isOpenDrawerSelection.value = false;
};

onBeforeMount(async () => {
  emptyCotizacionCantidadList();
  await findAllCotizacionCantidadHTTP({
    CodigoCliente: proposal.value.Cliente?.Codigo,
    page: 0,
    limit: 200,
    CodigoEstado: 2,
  });

  const savedCotizacionCantidad = [];
  proposal.value.PropuestaCotizacionCantidad.forEach((cotizacion) => {
    savedCotizacionCantidad.push(...cotizacion.items.map((i) => i.CodigoCotizacionCantidad));
  });
});
</script>

<style scoped>
.fixed-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}
</style>
